




import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { MAX_IMAGE_DENSITY, getBriocheImageSize, isBriocheImage } from 'frontend/utils/brioche';
import { isServerEnv } from 'frontend/utils/environment';
import { appendGetParams } from 'frontend/utils/urls';

interface IInlineStyles {
  backgroundImage: string;
}

@Component
export default class BriocheBackgroundImage extends Vue {
  @Prop({ type: String, required: true }) readonly src!: string;
  @Prop(Number) readonly width!: number;
  @Prop(Number) readonly height!: number;

  get inlineStyles(): IInlineStyles {
    return {
      backgroundImage: `url('${this.briocheSrc}')`,
    };
  }

  get briocheSrc() {
    let src;
    if (isBriocheImage(this.src)) {
      let density = 2; // default to 2x
      if (!isServerEnv) {
        density = Math.round(Math.min(window.devicePixelRatio, MAX_IMAGE_DENSITY));
      }
      const { dimension, amount } = getBriocheImageSize(this.width, this.height);
      src = appendGetParams(this.src, {
        [dimension]: amount * density,
      });
    } else {
      src = this.src;
    }

    // Brioche image is already encoded
    return isBriocheImage(this.src) ? src : encodeURI(src);
  }

  created() {
    if (!this.width && !this.height) {
      throw new Error('BriocheBackgroundImage requires either a "width" or a "height" prop');
    }
  }
}
